import _styled from "styled-components";
import React from "react";
import { ReactComponent as MenuIcon } from "@svgr/webpack?-svgo,+titleProp,+ref!@smartheat/common/svg/menu.svg";
import { Header } from "../Header/Header";
import { useConfig } from "../Config/useConfig";
import { useMenuApi } from "../MenuContainer/useMenuApi";
import { useHardwareInfo } from "../DeviceData/useHardwareInfo";
import { useApiVersion } from "../DeviceData/useApiVersionQuery";
import { Hw1Page } from "./hw_pages/Hw1Page";
import { Hw2Page } from "./hw_pages/Hw2Page/Hw2Page";
import { Hw3Page } from "./hw_pages/Hw3Page/Hw3Page";
import { Hw4Page } from "./hw_pages/Hw4Page/Hw4Page";
import { TextPage } from "../TextPage/TextPage";

var Container = _styled.div.withConfig({
  displayName: "StartPage__Container",
  componentId: "kc75cu-0"
})(["font-size:16px;display:flex;flex-direction:column;"]);

var PumpNameContainer = _styled.div.withConfig({
  displayName: "StartPage__PumpNameContainer",
  componentId: "kc75cu-1"
})(["margin-top:60px;display:flex;justify-content:center;font-size:30px;@media screen and (max-width:419px){font-size:24px;}"]);

var OneCenterElement = _styled.div.withConfig({
  displayName: "StartPage__OneCenterElement",
  componentId: "kc75cu-2"
})(["position:relative;display:flex;justify-content:center;margin:64px auto 40px;width:368px;height:368px;@media screen and (max-width:419px){width:288px;height:288px;margin:40px auto 32px;}"]);

var CircleElement = _styled.div.withConfig({
  displayName: "StartPage__CircleElement",
  componentId: "kc75cu-3"
})(["position:absolute;height:320px;width:320px;top:50%;left:50%;transform:translate(-50%,-50%);background-color:", ";border-radius:50%;display:flex;justify-content:center;opacity:", ";@media screen and (max-width:419px){height:240px;width:240px;}"], function (props) {
  return props.hasError ? "#dd4e4e" : "#4d9adf";
}, function (props) {
  return props.disabled ? 0.3 : 1;
});

var ErrorContent = _styled.div.withConfig({
  displayName: "StartPage__ErrorContent",
  componentId: "kc75cu-4"
})(["font-size:20px;color:white;width:270px;display:flex;flex-direction:column;align-items:center;justify-content:space-between;"]);

var ErrorMessage = _styled.div.withConfig({
  displayName: "StartPage__ErrorMessage",
  componentId: "kc75cu-5"
})(["font-size:36px;margin-top:65px;text-align:center;@media screen and (max-width:419px){font-size:30px;margin-top:45px;}"]);

var ErrorInfo = _styled.div.withConfig({
  displayName: "StartPage__ErrorInfo",
  componentId: "kc75cu-6"
})(["margin-bottom:48px;@media screen and (max-width:419px){margin-bottom:32px;}"]);

var NumberRow = _styled.div.withConfig({
  displayName: "StartPage__NumberRow",
  componentId: "kc75cu-7"
})(["font-size:24px;text-align:center;"]);

var TextRow = _styled.div.withConfig({
  displayName: "StartPage__TextRow",
  componentId: "kc75cu-8"
})(["font-size:22px;text-align:center;@media screen and (max-width:419px){font-size:18px;padding:0 24px;}"]);

function CircleLayout(_ref) {
  var backTo = _ref.backTo,
      hardwareInfo = _ref.hardwareInfo,
      children = _ref.children;
  var menuApi = useMenuApi();
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Header, {
    backTo: backTo,
    actionIcon: MenuIcon,
    onAction: menuApi.open
  }), /*#__PURE__*/React.createElement(PumpNameContainer, null, hardwareInfo.modelName || "\xA0"), children);
}

export function StartPage() {
  var config = useConfig();
  var apiVersion = useApiVersion();
  var hardwareInfo = useHardwareInfo();
  var backTo = config.backLocation || undefined;

  if (apiVersion === 0) {
    return /*#__PURE__*/React.createElement(TextPage, {
      backTo: backTo
    }, "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...");
  }

  if (apiVersion !== 4) {
    return /*#__PURE__*/React.createElement(CircleLayout, {
      hardwareInfo: hardwareInfo,
      backTo: backTo
    }, /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
      hasError: true
    }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(ErrorMessage, null, "\u041E\u0448\u0438\u0431\u043A\u0430: \u0412\u0410"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр"))))));
  }

  if (hardwareInfo.controllerApi === "hw1") {
    return /*#__PURE__*/React.createElement(CircleLayout, {
      hardwareInfo: hardwareInfo,
      backTo: backTo
    }, /*#__PURE__*/React.createElement(Hw1Page, null));
  }

  if (hardwareInfo.controllerApi === "hw2") {
    return /*#__PURE__*/React.createElement(CircleLayout, {
      hardwareInfo: hardwareInfo,
      backTo: backTo
    }, /*#__PURE__*/React.createElement(Hw2Page, null));
  }

  if (hardwareInfo.controllerApi === "hw3") {
    return /*#__PURE__*/React.createElement(CircleLayout, {
      hardwareInfo: hardwareInfo,
      backTo: backTo
    }, /*#__PURE__*/React.createElement(Hw3Page, null));
  }

  if (hardwareInfo.controllerApi === "hw4") {
    return /*#__PURE__*/React.createElement(Hw4Page, null);
  }

  return /*#__PURE__*/React.createElement(CircleLayout, {
    hardwareInfo: hardwareInfo,
    backTo: backTo
  }, /*#__PURE__*/React.createElement(OneCenterElement, null, /*#__PURE__*/React.createElement(CircleElement, {
    hasError: true
  }, /*#__PURE__*/React.createElement(ErrorContent, null, /*#__PURE__*/React.createElement(ErrorMessage, null, "\u041E\u0448\u0438\u0431\u043A\u0430: \u0412\u041A"), /*#__PURE__*/React.createElement(ErrorInfo, null, /*#__PURE__*/React.createElement(NumberRow, null, "+7(499)704-13-98"), /*#__PURE__*/React.createElement(TextRow, null, "обратитесь в сервисный центр"))))));
}